import { axios, getConfigs, IRequestConfig } from './api'
import { GeneratorInstanceDto } from './dtos'

export class GeneratorInstanceService {
  private static readonly endpoint = 'generator-instance'

  static getOne(id: string): Promise<GeneratorInstanceDto> {
    return new Promise((resolve, reject) => {
      const configs: IRequestConfig = getConfigs(
        'get',
        'application/json',
        `${this.endpoint}/${id}`,
        { baseURL: process.env.REACT_APP_RADIOPHARMACY_API_URL }
      )
      axios(configs, resolve, reject)
    })
  }
}
